import { takeLatest, putResolve, call, put } from 'redux-saga/effects';
import { executeImmediateRules } from '@gcc/configurator';
import isEmpty from 'lodash/isEmpty';
import {
  preloadStore,
  preloadRooms,
  preloadColorFamilies,
  preloadSteps,
  updatePath,
  preloadCarpetSwatch,
  preloadCarpetPad,
  preloadCarpetType,
} from '../actions/pathActions';
import { storeById } from '../api/storeInfoApi';
import safeSaga from './safeSaga';

function* loadDataFromUrl() {
  // Only run on client side
  if (typeof window === 'undefined') return;

  const queryParams = new URLSearchParams(window.location.search);
  const [key, storeId] = (queryParams.get('store').split('-'));
  const persistedStore = yield call(storeById, parseInt(storeId, 10));
  if (!isEmpty(persistedStore)) {
    yield putResolve(preloadStore(persistedStore));
  }
  yield put(preloadRooms(queryParams.get('rooms'), queryParams.has('isEdit')));
  yield put(preloadSteps(queryParams.get('steps')));
  yield put(preloadCarpetPad(queryParams.get('pad')));
  yield put(preloadCarpetType(queryParams.get('carpettype')));
  yield put(preloadColorFamilies(queryParams.get('multiChoice')));
  yield putResolve(preloadCarpetSwatch(true));
  yield putResolve(updatePath());

  try {
    yield putResolve(executeImmediateRules());
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(`Persist data saga failed: ${err.message}`);
  }
}

export function* persistDataSaga() {
  yield takeLatest('GCC_CONFIGURATOR/CONFIGURATOR_LOAD_SUCCESS', safeSaga(loadDataFromUrl));
}
